EC.accordion = function () {
  
  'use strict';

  function init () {
    const accordionBlocks = document.querySelectorAll('.js-faqs');
    if (accordionBlocks.length) {
      accordionBlocks.forEach((block) => {
        const target = block.querySelector('.js-faqs__button');
        if (target) {
          target.addEventListener('click', () => {
            // Toggle active class
            block.classList.toggle('is-active');
            // Toggle aria expanded
            const targetState = (target.getAttribute('aria-expanded') === 'true');
            target.setAttribute('aria-expanded', !targetState);
          });
        }
      });
    }
  }

  return {
    init: init
  };

}();
